import HilightTable from "../../../../components/HilightTable";
import React from "react";
import {withNamespaces} from "react-i18next";
import ContentPackageStatus from "../../../../components/ContentPackageStatus";
import CheckboxDefaultContent from "../../../../components/CheckboxDefaultContent";
import NetworkDeviceContentActionButtons from "./NetworkDeviceContentActionButtons";
import DeviceContentInfoColumn from "../../../../components/DeviceContentInfoColumn";
import {connect} from "react-redux";
import Moment from "react-moment";
import {formatterHelper} from "../../../../helpers/formatter-helper";
import {claimTypes} from "../../../../constants/claim.constants";
import {userHelper} from "../../../../helpers/user-helper";
import NetworkDeviceContentIconHelper from "../_helpers/NetworkDeviceContentIconHelper";
import {Button} from "react-bootstrap";
import JSONPretty from "react-json-pretty";

const NetworkDeviceContentTable = ({device, user, list, scenarioId = null, t}) => {
    const networkDeviceContentCrud    = user[`c_network-device-content.actions.crud`] || null;
    let resultList = list;

    if(scenarioId === 'no-selected' ) {
        resultList = list?.filter(args => args.exhibitionScenarioId === null)
    }
    else if(scenarioId !== null) {
        resultList = list?.filter(args => args.exhibitionScenarioId === scenarioId);
    }

    const columns = [
        {
            Header: '',
            id: 'expander',
            disableFilters: true,
            headerClassName: "text-center wrapok",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
            Cell: ({ row }) => {
                return (
                    row.original.defaultApp.label !== 'launcher' || (
                        <span {...row.getToggleRowExpandedProps()}>
                            {row.isExpanded ? (
                                <Button size={"sm"} variant={"outline-info"}>
                                    <i className="fas fa-arrow-right"/>
                                </Button>
                            ) : (
                                <Button size={"sm"} variant={"outline-info"}>
                                    <i className="fas fa-arrow-down"/>
                                </Button>
                            )}
                        </span>
                    )
            )}
        },
        {
            Header: '#',
            accessor: 'id',
            headerClassName: "text-center wrapok",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
        },
        {
            Header: 'type',
            headerClassName: "text-center wrapok",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return <NetworkDeviceContentIconHelper type={data.defaultApp?.label} />;
            }
        },
        {
            Header: 'label',
            accessor: 'label',
            headerClassName: "text-left wrapok",
            classNameRow: 'text-left wrapok',
            Cell: (props) => {
                const data = props.row.original;
                return (<DeviceContentInfoColumn content={data} />)
            },
        },
        {
            Header: 'exhibition-scenario',
            accessor: 'exhibitionScenario.label',
            show: userHelper.getUseExhibitionScenario(user)
        },
        {
            Header: 'is-default',
            accessor: 'isDefault',
            headerClassName: "text-center",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return (<CheckboxDefaultContent contentModel={data} />);
            },
        },
        {
            Header: 'upload-date',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            headerClassName: "text-center",
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return (<Moment format="YYYY-MM-DD HH:mm">{data.uploadDate}</Moment>)
            }
        },
        {
            Header: 'file-size',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            headerClassName: "text-center",
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return formatterHelper.byteToMegabyte(data.fileSize) + " MB";
            }
        },
        {
            Header: 'status',
            accessor: 'status',
            headerClassName: "text-center wrapok",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <ContentPackageStatus packageStatus={data.packageStatus}/>
                );
            },
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            show: networkDeviceContentCrud === claimTypes.READ_WRITE,
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <NetworkDeviceContentActionButtons row={data} device={device} />
                )
            }
        }
    ];

    const renderRowSubComponent = (row) => {
        const { original } = row;

        // sub child Columns
        const subColumns = [...columns];
        subColumns.forEach(item => {
            if(item.id === 'expander')
                item.show = false
        });

        return (
            <div className="col-md-12 mx-0 my-3 p-0">
                <h5>{ t('launcher-items') }</h5>
                { original.launcherItems?.length ? (
                    <HilightTable
                        columns={subColumns}
                        data={original.launcherItems}
                    />
                ) : (
                    <div className="text-center p-4">
                        <h3>{ scenarioId ? t('network-device-content-no-content-scenario') : t('network-device-content-no-content') }</h3>
                    </div>
                ) }
            </div>
        )
    };

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { resultList?.length ? (
                <HilightTable
                    columns={columns}
                    data={resultList}
                    renderRowSubComponent={renderRowSubComponent}
                />

            ) : (
                <div className="text-center p-4">
                    <h3>{ scenarioId ? t('network-device-content-no-content-scenario')  : t('network-device-content-no-content')  }</h3>
                </div>
            ) }
        </div>
    )
};

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentTable));
